import { Box } from "@mui/material";
import React from "react";
import "../Suites.css";

interface SuitesAppProps {
  appTitle: string;
  activeApp: string;
  appIcon: any;
}

export const SuitesNavbarItem = ({
  appTitle,
  appIcon,
  activeApp,
}: SuitesAppProps) => {
  return (
    <Box
      className={`suites-app ${activeApp === appTitle && "active"} ${
        appTitle !== "Text" && "before-effect"
      }`}
    >
      {appIcon}
      <span className={`app-name ${activeApp === appTitle && "active"}`}>
        {appTitle}
      </span>
    </Box>
  );
};
